import { DateTimeFactory } from "../../../../localization/useDateTime"
import { DeliveryLocationDetails, CreateOrEditDeliveryLocationFormValues } from "../deliveryLocationsTypes"

export const prepareInitialValues = (
    dateTimeFactory: DateTimeFactory,
    deliveryLocationResult?: DeliveryLocationDetails,
): CreateOrEditDeliveryLocationFormValues => {
    const timeIntervalStart = dateTimeFactory.fromISO(deliveryLocationResult?.timeInterval?.start ?? "10:00")
    const timeIntervalEnd = dateTimeFactory.fromISO(deliveryLocationResult?.timeInterval?.end ?? "12:00")

    return {
        name: deliveryLocationResult?.name ?? "",
        description: deliveryLocationResult?.description ?? "",
        isActive: deliveryLocationResult?.isActive ?? true,
        timeIntervalStart,
        timeIntervalEnd,
        webshopId: deliveryLocationResult?.webshop?.id ?? "",
    }
}
